import { useCallback, useState } from 'react';

import { usePlanCodeValidatorQuery } from '../queries';

export const useValidatePlanCodesOnServer = () => {
  const { onSubmit: validatePlanCodes } = usePlanCodeValidatorQuery();
  const [isValidating, setIsValidating] = useState(false);

  const validate = useCallback(
    async (params: { orgId?: string; codes: string[] }): Promise<string[]> => {
      if (params.codes.length === 0) return [];

      try {
        setIsValidating(true);
        const response = await validatePlanCodes(params);

        if (Array.isArray(response)) {
          return response
            .filter((item: { plan_code: string; is_valid: boolean }) => !item.is_valid)
            .map((item) => item.plan_code);
        }

        return [];
      } catch {
        // If validation request fails, don't block navigation
        return [];
      } finally {
        setIsValidating(false);
      }
    },
    [validatePlanCodes]
  );

  return { validate, isValidating };
};
